import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BoostrapAthleteResultsComponent } from './components/boostrap-athlete-results/boostrap-athlete-results.component';

const routes: Routes = [
  {path:'', component:BoostrapAthleteResultsComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AthleteResultsRoutingModule { }
